import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { services as staticServices } from '../data/services';

const ServiceContext = createContext();

export const useServices = () => {
    const context = useContext(ServiceContext);
    if (!context) {
        throw new Error('useServices must be used within a ServiceProvider');
    }
    return context;
};

export const ServiceProvider = ({ children }) => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [globalSearchQuery, setGlobalSearchQuery] = useState('');

    const API = process.env.REACT_APP_BACKEND_URL + '/api';

    const fetchServices = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API}/services`);
            setServices(response.data);
            setError(null);
        } catch (err) {
            console.error('Failed to fetch services:', err);
            setError('Failed to load services');
        } finally {
            setLoading(false);
        }
    }, [API]);

    useEffect(() => {
        fetchServices();
    }, [fetchServices]);

    return (
        <ServiceContext.Provider value={{ services, loading, error, refreshServices: fetchServices, globalSearchQuery, setGlobalSearchQuery }}>
            {children}
        </ServiceContext.Provider>
    );
};
